@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.notifications

data class ExtendedNotificationDto (
    val notification: NotificationDto,
    val notificationRead: NotificationReadDto?,
)